import { render, staticRenderFns } from "./usercfa.vue?vue&type=template&id=3bf39c16&scoped=true"
import script from "./usercfa.vue?vue&type=script&lang=js"
export * from "./usercfa.vue?vue&type=script&lang=js"
import style0 from "./usercfa.vue?vue&type=style&index=0&id=3bf39c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf39c16",
  null
  
)

export default component.exports